/**
 * Pure helpers for applying equipment to an appearance. Equipping writes the item's
 * (styleId, colorId) into the slot's appearance fields; unequipping clears them. Kept
 * separate from appearance.ts so it can import the item→equip mapping from constants.ts.
 */
import { itemEquip } from "./constants.js";
const SLOT_FIELDS = {
    top: ["top", "topColor"],
    bottom: ["bottom", "bottomColor"],
    shoes: ["shoes", "shoesColor"],
    hat: ["hat", "hatColor"],
    mask: ["mask", "maskColor"],
    back: ["backAcc", "backAccColor"],
};
/** New appearance with `equip`'s style+color written into its slot. */
export function applyEquip(a, equip) {
    const [styleKey, colorKey] = SLOT_FIELDS[equip.slot];
    return { ...a, [styleKey]: equip.styleId, [colorKey]: equip.colorId };
}
/** New appearance with `slot` cleared (style+color = 0). */
export function clearSlot(a, slot) {
    const [styleKey, colorKey] = SLOT_FIELDS[slot];
    return { ...a, [styleKey]: 0, [colorKey]: 0 };
}
/** The (style, color) currently worn in a slot. */
export function slotEquip(a, slot) {
    const [styleKey, colorKey] = SLOT_FIELDS[slot];
    return { styleId: a[styleKey], colorId: a[colorKey] };
}
/** The gear appearance with the COSMETIC layer overlaid — each worn cosmetic overrides its gear
 *  slot's visual. This is the single "display appearance" rule shared by the in-world avatars,
 *  the portrait/bust composers, and the casino seat bake. Gating (cosmetics toggled off, working,
 *  Kapon) stays at the call sites — this helper only applies the overlay. */
export function applyCosmetics(a, cos) {
    for (const id of [cos.cosHat, cos.cosTop, cos.cosBottom, cos.cosShoes]) {
        const eq = id ? itemEquip(id) : undefined;
        if (eq)
            a = applyEquip(a, eq);
    }
    return a;
}
//# sourceMappingURL=equip.js.map